<template>
  <div class="main about">
    <!-- <div class="content">
      <div class="about">
        <p class="title" :style="{ color: textColor }" id="title">{{ title }}</p>
        <div class="desc" :style="{ color: textColor }">
          <div v-for="(item, index) in desc" :key="index">
            <ul v-if="item.type === 'list'">
              <li v-for="(list, index) in item.text" :key="index">
                {{ index + 1 }}. {{ list }}
              </li>
            </ul>
            <span v-else>{{ item.text }}</span>
          </div>
        </div>
      </div>
    </div> -->
    <div class="header-seciton">
      <Header></Header>
      <div class="page1">
        <div class="wrap">
          <h1>Discover the services we provide</h1>
          <div class="desc">Discover the future of companionship with Spicy Chat, where artificial intelligence meets human connection. Our app offers more than just conversation—it offers a deep, engaging experience with your virtual AI companion. Immerse yourself in a world where your AI friend is always ready to listen, offer support, and share in the moments that matter most to you.</div>
          <a href="https://play.google.com/store/apps/details?id=ai.spicy.spicychat.mate" target="_blank" class="btn">Get Started</a>
        </div>
      </div>
    </div>
    <div class="page2">
      <h1>About Us</h1>
      <div class="desc">Spicy Chat: The Ultimate Application of AI-Driven Romance and Companionship.</div>
      <div class="desc">Spicy Chat is not just a chatbot; it's a true virtual partner who can send you everyday life photos, including selfies. Whether you want to see her by the pool in a bikini in summer or dressed in special Halloween costumes.</div>
      <div class="desc">Don't settle for ordinary when it comes to your virtual companionship. Spicy Chat is the cutting-edge solution for those who desire a more vivid and interactive social experience in the digital age. Join us today and let Spicy Chat redefine what it means to have a virtual friend who is always there for you.</div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default {
  components: {Header, Footer},
  data() {
    return {
      title: "",
      desc: [],
    };
  },
  computed: {
    textColor: function() {
      return this.$store.state.data.theme.desc_color;
    },
  },
  created() {
    this.renderUI();
  },
  methods: {
    renderUI() {
      const config = this.$store.state.data;
      const { title, desc } = config.page[1];
      this.title = title;
      this.desc = desc;
    },
  },
};
</script>

<style lang="less" scoped>
.main.about{
  .header-seciton{
    background-image: url("~@/assets/images/bannerbg2.png");
  }
  .page1{
    .wrap{
      max-width: 800px;
      text-align: center;
      position: relative;
      top: -20px;
      h1{
        margin-top: 0;
        text-transform: capitalize;
      }
      .desc{
        line-height: 30px;
      }
      .btn{
        display: inline-block;
        font-size: 18px;
        padding: 17px 38.5px;
        background: #ff8a42;
        line-height: 26px;
        color: #fff;
        font-weight: 500;
        border-radius: 30px;
        text-transform: capitalize;
        transition: all 500ms ease;
        cursor: pointer;
        text-align: center;
        z-index: 1;
        box-shadow: 0 15px 20px rgba(71,25,171,0.10);
        text-decoration: none;
        font-family: 'Poppins',sans-serif;
        transition: all 500ms ease;
        margin-top: 60px;
        &:hover{
          background: #00c569;
        }
      }
    }
  }
}
.content {
  padding: 10px 0;
  flex: 1;
  background-image: url("~@/assets/images/about.png");
  background-size: cover;
  width: 100%;
  display: flex;
  align-items: center;
  .about {
    // max-width: 960px;
    transform: translateX(36%);
    width: 54%;
    .title {
      font-size: 33px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
      line-height: 46px;
    }
    .desc {
      width: 80%;
      line-height: 24px;
      div {
        margin-bottom: 15px;
      }
      ul {
        margin-top: 10px;
      }
      ul li {
        margin-left: 20px;
        font-size: 18px;
      }
    }
  }
}
</style>
